package com.example.readingnotes.presentation.postlist

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.model.TagWithCount
import com.example.readingnotes.platform.FavoriteSearch

data class PostListState(
    val isLoading: Boolean = false,
    val isRefreshing: Boolean = false,
    val isLoadingMore: Boolean = false,
    val errorMessage: String? = null,
    val posts: List<Post> = emptyList(),
    val currentPage: Int = 1,
    val totalPages: Int = 1,
    val hasMore: Boolean = true,
    // Search functionality
    val searchQuery: String = "",
    val isSearchActive: Boolean = false,
    val searchResults: List<Post> = emptyList(),
    val searchSuggestions: List<String> = emptyList(),
    val isLoadingSuggestions: Boolean = false,
    val showSuggestions: Boolean = false,
    // Search history
    val searchHistory: List<String> = emptyList(),
    // Sort functionality
    val sortBy: SortOption = SortOption.NEWEST,
    // Filter functionality
    val statusFilter: String? = null, // "published", "draft", "archived", null for all
    val selectedTags: Set<String> = emptySet(),
    val popularTags: List<TagWithCount> = emptyList(),
    val isLoadingTags: Boolean = false,
    // Settings
    val pageSize: Int = 20,
    val autoSearch: Boolean = true,
    // Favorite searches
    val favoriteSearches: List<FavoriteSearch> = emptyList(),
    val showFavoriteDialog: Boolean = false,
    val favoriteNameInput: String = "",
)

enum class SortOption {
    NEWEST,
    OLDEST,
    TITLE_ASC,
    TITLE_DESC,
}
